export default "__VITE_ASSET__Cs8jX5Hm__"